import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { GenericLinkModule } from '../../generic-link/generic-link.module';
import { ShimanoLinkModule } from '../../link/link.module';
import { ProductManualComponent } from './product-manual.component';

@NgModule({
  imports: [
    CommonModule,
    GenericLinkModule,
    ShimanoLinkModule,
    MatIconModule,
    MatButtonModule,
    MatExpansionModule,
    I18nModule,
    UrlModule,
    ProductManualComponent,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductManualsComponent: {
          component: ProductManualComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  exports: [ProductManualComponent],
})
export class ProductManualModule {}
